var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterApplied({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 18.1137 0 18.1137 20 0 20"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/System/Filter/Applied/20px",
    stroke: "none",
    strokeWidth: 1,
    fill: "#00A0AF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1, 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A0AF",
    d: "M16.4037,2 L1.7037,2 L0.9937,1 L17.1137,1 L16.4037,2 Z M14.9737,4 L3.1337,4 L2.4237,3 L15.6837,3 L14.9737,4 Z M13.5437,6 L4.5637,6 L3.8537,5 L14.2537,5 L13.5437,6 Z M12.1137,8 L5.9937,8 L5.2837,7 L12.8237,7 L12.1137,8 Z M10.6837,10 L7.4237,10 L6.7137,9 L11.3937,9 L10.6837,10 Z M10.0537,17 L10.0537,18.22 L8.0537,18.72 L8.0537,17 L10.0537,17 Z M8.0537,16 L10.0537,16 L10.0537,15 L8.0537,15 L8.0537,16 Z M8.0537,12 L10.0537,12 L10.0537,11 L8.0537,11 L8.0537,12 Z M8.0537,14 L10.0537,14 L10.0537,13 L8.0537,13 L8.0537,14 Z M17.1137,0 L0.9937,0 C0.2337,0 -0.2263,0.82 0.1137,1.46 C0.1337,1.5 0.1537,1.54 0.1837,1.58 L0.4837,2 L1.1937,3 L1.9137,4 L2.6237,5 L3.3437,6 L4.7637,8 L5.4837,9 L6.1937,10 L6.9137,11 L7.0537,11.2 L7.0537,20 L11.0537,19 L11.0537,11.2 L11.1937,11 L11.9137,10 L12.6237,9 L13.3437,8 L14.7637,6 L15.4837,5 L16.1937,4 L16.9137,3 L17.6237,2 L17.9237,1.58 C18.0537,1.4 18.1137,1.2 18.1137,1 C18.1137,0.48 17.7037,0 17.1137,0 L17.1137,0 Z",
    id: "Fill-1",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterApplied);
export default __webpack_public_path__ + "static/media/Filter_Applied.8644d1f13795dfa377a3377ccb26a0c3.svg";
export { ForwardRef as ReactComponent };